import axios from "axios";
import { getJwtToken } from "../Auth0/SessionProvider";

const baseURL = process.env.REACT_APP_DRUPAL_BASE_URL || "/";

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*"
  }
});

instance.interceptors.request.use(async (config) => {
  const token = await getJwtToken();
  if(!token) {
    throw new axios.Cancel('Request cancelled due to invalid token');
  }
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const makeAContributionAPI = {
  step1Content: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/makeAContribution/info/make-a-contribution-step1`);
    } else {
      return instance.get(
        `/make-a-contribution-step1?Page=Make a Contribution`
      );
    }
  },
  step1Notice: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/notices/PageMake_a_Contribution`);
    } else {
      return instance.get(`/notices?Page=Make a Contribution`);
    }
  },
  step2Notice: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/notices/PageMake_a_Contribution2`);
    } else {
      return instance.get(`/notices?Page=Make a Contribution2`);
    }
  },
  step3Disclaimer: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/disclaimers/PageMake_a_Contribution3`);
    } else {
      return instance.get(`/disclaimers?Page=Make a Contribution3`);
    }
  },
  wiringInstructions: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/api/contribution-flow/NameWiring-Instructions`);
    } else {
      return instance.get(`/api/contribution-flow?Name=Wiring-Instructions`);
    }
  },
  successMessage: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/makeAContribution/confirmationMessage/message`);
    } else {
      return instance.get(`/confirmation-message?Page=Make a Contribution`);
    }
  },
  alertBox: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/makeAContribution/alert/alert`);
    } else {
      return instance.get(`/alert?Page=Make a Contribution`);
    }
  }
};

export const contributionActivityAPI = {
  getPageDetails: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/contributionActivity/page/activity/pageDetails`);
    } else {
      return instance.get(
        `api/page-title-description?name=Contribution Activity`
      );
    }
  },
  alertBox: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/contributionActivity/alert/contribCancel`);
    } else {
      return instance.get(`/alert?Page=Contribution Activity`);
    }
  }
};

export const ViewContributionAPI = {
  getNotice: () => {
    if (process.env.REACT_APP_NODE_ENV === "development") {
      return instance.get(`/notices/PageView_Contribution`);
    } else {
      return instance.get(`/notices?Page=View Contribution`);
    }
  }
};

export const RecommendAnExchangeAPIs = {
  getInvestmentFunds: ({ value }) => {
    return instance.get(`/investment-api-funds`, {
      params: {
        poolname: value
      }
    });
  },
  getInvestmentUnderlyingFunds: ({ value }) => {
    return instance.get(`/investment-underlying-funds-api`, {
      params: {
        poolname: value
      }
    });
  }
};

export const ContentMessagesAPIs = {
  getPageTitleAndDescription: ({ name }) => {
    return instance.get("/api/page-title-description", {
      params: {
        name
      }
    });
  },
  getNotices: ({ page }) => {
    return instance.get("/notices", {
      params: {
        Page: page
      }
    });
  },
  getDisclaimers: ({ page }) => {
    return instance.get("/disclaimers", {
      params: {
        Page: page
      }
    });
  },
  getPDFLinks: () => {
    return instance.get("/policies-and-guidelines");
  },
  getEndowedGrantPlanPDFLinks: () => {
    return instance.get("/endowed-grant");
  },
  getSubHeadingLegacyOptions: ({ name }) => {
    return instance.get("/make-a-contribution-step1", {
      params: {
        Page: name
      }
    });
  },
  getConfirmationMessageFromDrupal: ({ name }) => {
    return instance.get("/confirmation-message", {
      params: {
        Page: name
      }
    });
  },
  getModalContent: ({ page }) => {
    return instance.get("/get_modal_content", {
      params: {
        Page: page
      }
    });
  },
  getAlertMessagesFromDrupal: ({ name }) => {
    return instance.get("/alert", {
      params: {
        Page: name
      }
    });
  },
  getPleaseNoteFromDrupal: ({ page }) => {
    return instance.get("/please-note", {
      params: {
        Page: page
      }
    });
  },
  getPTPFromDrupal: ({ name }) => {
    return instance.get("/permission-to-publish", {
      params: {
        Page: name
      }
    });
  },
  getCheckboxFromDrupal: ({ name }) => {
    return instance.get("/dp-checkbox", {
      params: {
        Page: name
      }
    });
  }
};
export const GetNoticeAPI = {
  getNoticeContent: () => {    
      return instance.get(`/notices?Page=Account Summary`);
  }
};
